window.myCompanyNameSpace={};
myCompanyNameSpace.SAMPLE_CONFIGS={};
myCompanyNameSpace.SAMPLE_CONFIGS_EXPLANATIONS={};
myCompanyNameSpace.SAMPLE_CONFIGS_DETAIL_URLS={};
myCompanyNameSpace.SAMPLE_CONFIGS_DETAIL_BEAUTIFIED={};
myCompanyNameSpace.IMAGE_PATH="content/htmltreegridfiles/images"; //for prod
//myCompanyNameSpace.IMAGE_PATH="app/scripts/htmltreegridfiles/images";
//myCompanyNameSpace.Constants.IMAGE_PATH="scripts/htmltreegridfiles/images";
